import React from 'react';
import './Timeline.css';
import realcarMencoes from '../../../App/Components/Mencao/realcarMencoes';

function formatarDataHora(dataHora) {
    if (!dataHora) return '—';
    const d = new Date(dataHora);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
}

function Timeline({ eventos }) {
    const lista = Array.isArray(eventos) ? eventos : [];
    if (lista.length === 0) {
        return (
            <div className="sol-empty" style={{ padding: '2rem 1rem' }}>
                <div className="sol-empty-icon"><i className="fas fa-comments" /></div>
                <p className="sol-empty-text">Ainda não há trâmites para este chamado.</p>
            </div>
        );
    }
    return (
        <ol className="sol-timeline">
            {lista.map((ev, idx) => (
                <li className="sol-timeline-item" key={idx}>
                    <span className="sol-timeline-dot"><i className="fas fa-circle" /></span>
                    <div className="sol-timeline-body">
                        <div className="sol-timeline-head">
                            <span className="sol-timeline-autor"><i className="fas fa-user" /> {ev.autor_nome || 'Atendimento'}</span>
                            <span className="sol-timeline-data">{formatarDataHora(ev.data)}</span>
                        </div>
                        <p className="sol-timeline-text">{ev.descricao ? realcarMencoes(ev.descricao) : '—'}</p>
                    </div>
                </li>
            ))}
        </ol>
    );
}

export default Timeline;
